import { render, staticRenderFns } from "./BAEventsAttendeesManagement.vue?vue&type=template&id=2e508647&"
import script from "./BAEventsAttendeesManagement.vue?vue&type=script&lang=ts&"
export * from "./BAEventsAttendeesManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports